var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStarA(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6292 12.6104L18 2.23607L21.3708 12.6104C21.6051 13.3315 22.277 13.8197 23.0352 13.8197H33.9434L25.1185 20.2314C24.5051 20.677 24.2485 21.4669 24.4828 22.1879L27.8536 32.5623L19.0286 26.1506C18.4153 25.705 17.5847 25.705 16.9714 26.1506L8.14641 32.5623L11.5172 22.1879C11.7515 21.4669 11.4949 20.677 10.8815 20.2314L2.05655 13.8197H12.9648C13.723 13.8197 14.3949 13.3315 14.6292 12.6104ZM34.5659 13.3674L34.5655 13.3677L34.5659 13.3674Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarA);
export default __webpack_public_path__ + "static/media/icon-star-A.0d3b5d87fc4070fb1346bc977adec0bd.svg";
export { ForwardRef as ReactComponent };